import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProduct } from "features/hosting/hostingAPI";
import { fetchAddonsVPS, fetchProductsPromoVPS } from "./vpsAPI";

const initialState = {
  products: [],
  addonsSpecial: [],
  addonsVPS: [],
  operatingSystem: null,
  status: {
    products: "idle",
    addonsSpecial: "idle",
    addonsVPS: "idle",
  },
  error: {
    products: "",
    addonsSpecial: "",
    addonsVPS: "",
  },
};

export const getVpsByServer = createAsyncThunk(
  "vps/getVpsByGroup",
  async (gid) => {
    const response = await fetchProduct(gid);
    return response;
  }
);

export const getAddonsVPS = createAsyncThunk(
  "vps/getAddonsVPS",
  async (pid) => {
    const response = await fetchAddonsVPS(pid);
    return response;
  }
);
export const getProductsPromoVPS = createAsyncThunk(
  "products/getFromGIDPromoVPS",
  async (data) => {
    const response = await fetchProductsPromoVPS(data);
    return response;
  }
);

const vpsSlice = createSlice({
  name: "vps",
  initialState,
  reducers: {
    updateOperatingSystem: (state, action) => {
      state.operatingSystem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVpsByServer.pending, (state) => {
      state.status.products = "loading";
      state.products = [];
    });
    builder.addCase(getVpsByServer.fulfilled, (state, action) => {
      const { product } = action.payload.products;
      state.products = product;
      state.status.products = "idle";
    });
    builder.addCase(getVpsByServer.rejected, (state, action) => {
      state.status.products = "idle";
      state.products = [];
      state.error = action.error.message;
    });
    builder.addCase(getAddonsVPS.pending, (state) => {
      state.status.addonsVPS = "loading";
      state.addonsVPS = [];
    });
    builder.addCase(getAddonsVPS.fulfilled, (state, action) => {
      const { addons } = action.payload.data[0];
      state.addonsVPS = addons;
      state.status.addonsVPS = "idle";
    });
    builder.addCase(getAddonsVPS.rejected, (state, action) => {
      state.status.addonsVPS = "idle";
      state.addonsVPS = [];
      state.error = action.error.message;
    });
    builder.addCase(getProductsPromoVPS.pending, (state) => {
      state.status.products = "loading";
      state.products = [];
    });
    builder.addCase(getProductsPromoVPS.fulfilled, (state, action) => {
      const { product } = action.payload.products;
      state.products = product;
      state.status.products = "idle";
    });
    builder.addCase(getProductsPromoVPS.rejected, (state, action) => {
      state.status.products = "idle";
      state.products = [];
      state.error = action.error.message;
    });
  },
});

export const vpsSelector = (state) => state.vps;
export const { updateOperatingSystem } = vpsSlice.actions;
export default vpsSlice.reducer;
